import styled from 'styled-components';

export const ProjectsSection = styled.section`
  padding: 6rem 0;
  position: relative;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding: 4rem 0;
  }
`;

export const ProjectsWrapper = styled.div`
  width: 90%;
  max-width: 1200px;
  margin: 0 auto;
`;

/* ── Grid Layout ────────────────────────────────────── */

export const ProjectsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 1.5rem;
  margin-top: 3rem;
`;

/* ── Project Card ───────────────────────────────────── */

export const ProjectCard = styled.div`
  background: ${({ theme }) => theme.colors.bg_card};
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid ${({ theme }) => theme.colors.glass_border};
  border-radius: ${({ theme }) => theme.radius.lg};
  overflow: hidden;
  transition: ${({ theme }) => theme.transitions.default};
  display: flex;
  flex-direction: column;

  &:hover {
    border-color: ${({ theme }) => theme.colors.glass_border_hover};
    box-shadow: ${({ theme }) => theme.shadows.card_hover};
    transform: translateY(-6px);
  }
`;

export const ProjectImageContainer = styled.div`
  position: relative;
  overflow: hidden;
  height: 180px;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    height: 200px;
  }
`;

export const ProjectImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: ${({ theme }) => theme.transitions.slow};

  ${ProjectCard}:hover & {
    transform: scale(1.05);
  }
`;

export const ProjectInfo = styled.div`
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
  flex: 1;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding: 1.25rem;
  }
`;

export const TechStackContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1rem;
`;

export const TechStackCard = styled.span`
  display: inline-block;
  background: rgba(59, 130, 246, 0.1);
  color: ${({ theme }) => theme.colors.accent_light};
  padding: 0.3rem 0.75rem;
  border-radius: ${({ theme }) => theme.radius.full};
  font-size: 0.75rem;
  font-weight: ${({ theme }) => theme.fonts.weight.medium};
  border: 1px solid rgba(59, 130, 246, 0.2);
`;

export const ProjectDescription = styled.p`
  color: ${({ theme }) => theme.colors.para};
  font-size: 0.85rem;
  line-height: 1.6;
  margin-bottom: 1.25rem;
  flex: 1;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const PlaceholderImage = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.bg_secondary};
  color: ${({ theme }) => theme.colors.muted};
  font-size: 3rem;
`;

/* ── Filter Bar ─────────────────────────────────────── */

export const FilterBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.5rem;
  margin-top: 2rem;
`;

export const FilterChip = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.45rem 1rem;
  font-size: 0.8rem;
  font-weight: ${({ theme }) => theme.fonts.weight.medium};
  border-radius: ${({ theme }) => theme.radius.full};
  cursor: pointer;
  transition: ${({ theme }) => theme.transitions.default};
  background: ${({ active, theme }) =>
    active ? theme.colors.accent_gradient : theme.colors.bg_card};
  color: ${({ active, theme }) =>
    active ? theme.colors.white : theme.colors.para};
  border: 1px solid
    ${({ active, theme }) =>
      active ? 'transparent' : theme.colors.glass_border};
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  box-shadow: ${({ active, theme }) =>
    active ? theme.shadows.button : 'none'};

  &:hover {
    color: ${({ active, theme }) =>
      active ? theme.colors.white : theme.colors.heading};
    border-color: ${({ active, theme }) =>
      active ? 'transparent' : theme.colors.glass_border_hover};
    transform: translateY(-1px);
  }
`;

export const FilterCount = styled.span`
  font-size: 0.7rem;
  opacity: 0.75;
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
`;

export const EmptyState = styled.div`
  grid-column: 1 / -1;
  text-align: center;
  padding: 3rem 1rem;
  color: ${({ theme }) => theme.colors.muted};
  font-size: 0.95rem;
`;
